<div class="container-main">
  <div>
    <member-member-detail-header></member-member-detail-header>
  </div>
  <div class="route-container">
    <router-outlet></router-outlet>
  </div>
</div>
